// extracted by mini-css-extract-plugin
export default {"fileUploader":"fileUploader__EYRZF","isDragging":"isDragging__6g9bU","btnBrowse":"btnBrowse__8u4M9"};